import React from 'react';
import { Tabs } from 'antd';
import BomTable from './BomTable';
import ProductionTable from './ProductionTable';

const onChange = (key) => {
  console.log(key);
};
const items = [
  {
    key: '1',
    label: 'BOM',
    children: <BomTable />,
  },
  {
    key: '2',
    label: 'PRODUCTION',
    children: <ProductionTable />,
  },
];
const TabsTable = () => {
  return (
    <>
    <div className="bg-white m-4 p-8 rounded-xl">
    <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
    </div>
 
    </>
  )
}

export default TabsTable